var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfilePhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 3C10.47 3 3.75 9.72 3.75 18C3.75 26.28 10.47 33 18.75 33C27.03 33 33.75 26.28 33.75 18C33.75 9.72 27.03 3 18.75 3ZM18.75 7.5C21.24 7.5 23.25 9.51 23.25 12C23.25 14.49 21.24 16.5 18.75 16.5C16.26 16.5 14.25 14.49 14.25 12C14.25 9.51 16.26 7.5 18.75 7.5ZM18.75 28.8C15 28.8 11.685 26.88 9.75 23.97C9.795 20.985 15.75 19.35 18.75 19.35C21.735 19.35 27.705 20.985 27.75 23.97C25.815 26.88 22.5 28.8 18.75 28.8Z",
    fill: "#5F6368"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePhoto);
export default __webpack_public_path__ + "static/media/profile-photo.98859ec6ce6865494b953c477341b040.svg";
export { ForwardRef as ReactComponent };